import request from '@/utils/http.js'

export function login(data) {
    return request({
        url: '/login',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}
export function addUnit(data) {
    return request({
        url: '/unit/admin/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function getUnitList(data) {
    return request({
        url: '/unit/list',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function updataUnit(data) {
    return request({
        url: '/unit/admin/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function delUnit(data) {
    return request({
        url: '/unit/admin/del',
        headers: {
            isToken: true
        },
        method: 'delete',
        data:data
    })
}
export function addBanner(data) {
    return request({
        url: '/banner/admin/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function getBannerList(data) {
    return request({
        url: '/banner/list',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}
export function updateBanner(data) {
    return request({
        url: '/banner/admin/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function delBanner(data) {
    return request({
        url: '/banner/admin/del',
        headers: {
            isToken: true
        },
        method: 'delete',
        data:data
    })
}
export function uploadFile(data) {
    return request({
        url: '/file/upload',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
